import { ArrowUpRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import MotionButton from "@/components/motion/MotionButton";

export default function CTASection() {
    const navigate = useNavigate();
    return (
        <section
            data-testid="cta-section"
            className="relative py-20 md:py-32"
        >
            <div className="mx-auto max-w-[1400px] px-6 md:px-10 lg:px-16">
                <div className="relative overflow-hidden rounded-3xl bg-[#E54D2E] text-white p-10 md:p-16 lg:p-20 motion-card">
                    {/* Decorative dots */}
                    <div className="absolute -top-16 -right-16 h-64 w-64 rounded-full bg-white/10 blur-2xl" />
                    <div className="absolute -bottom-20 -left-10 h-64 w-64 rounded-full bg-black/10 blur-2xl" />

                    <div className="relative grid grid-cols-1 lg:grid-cols-12 gap-10 items-end">
                        <div className="lg:col-span-8">
                            <div className="inline-flex items-center gap-2 text-xs font-mono uppercase tracking-[0.2em] text-white/80 mb-6">
                                <span className="h-1.5 w-1.5 rounded-full bg-white pulse-dot" />
                                Open call — next cohort
                            </div>
                            <h2 className="font-display text-5xl sm:text-6xl md:text-7xl font-black tracking-[-0.035em] leading-[0.92]">
                                Come build with us.
                            </h2>
                            <p className="mt-6 max-w-xl text-lg text-white/85 leading-relaxed">
                                We’ll be glad to host you in our next event.
                                Join the community, ship your project, and
                                demo it on stage.
                            </p>
                        </div>
                        <div className="lg:col-span-4 flex lg:justify-end">
                            <MotionButton
                                type="button"
                                onClick={() => navigate("/hackathon")}
                                data-testid="cta-join-btn"
                                className="group inline-flex items-center gap-3 h-16 pl-7 pr-3 rounded-full bg-zinc-950 text-white text-lg font-medium hover:bg-white hover:text-zinc-950 transition-colors"
                            >
                                Join Us
                                <span className="h-10 w-10 rounded-full bg-white/15 group-hover:bg-zinc-950 group-hover:text-white inline-flex items-center justify-center transition-colors">
                                    <ArrowUpRight className="h-5 w-5" />
                                </span>
                            </MotionButton>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
